import { CLIENT_PORTAL_ORIGIN } from 'app/constants/authentication';
import appEnv from 'app/config/appEnv';

const apiConfig = {
  baseURL: appEnv.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-aslan-origin': CLIENT_PORTAL_ORIGIN,
  },
};

export default apiConfig;
